export const DataConst = {
	MISSION_ORG_TYPES: ["MISSION", "ZONE", "DISTRICT", "AREA"],
	UNIT_ORG_TYPES: ["UNIT", "WARD", "WARD_OVERLAY", "STAKE", "STAKE_OVERLAY", "OTHER_UNIT"],
	CUSTOM_TYPE: "CUSTOM",
	GENERIC_UNIT_ORG_TYPES: ["UNIT", "OTHER_UNIT"],
	BOUNDARY_UNIT_ORG_TYPES: ["UNIT", "WARD", "WARD_OVERLAY", "STAKE", "STAKE_OVERLAY"],
	FACILITY_UNIT_ORG_TYPES: ["OTHER_UNIT", "HISTORIC_SITE", "VISITORS_CENTER", "MEETINGHOUSE", "TEMPLE"],
	OTF_ORG_TYPES: ["MEETINGHOUSE"],
	PARENT_UNIT_ORG_TYPES: ["STAKE", "STAKE_OVERLAY"],
	CHILD_UNIT_ORG_TYPES: ["WARD", "WARD_OVERLAY"],

	BOUNDARY_STATUS: [
		"DEFAULT",
		"MATCH",
		"DEFINED",
		"RESET",
		"FLAGGED"
	],
	SYNC_STATUS: [
		"SYNCED",
		"SUBMITTING",
		"SUBMITTED"
	]
};

export default DataConst;
